import { render, staticRenderFns } from "./IncidentIndex.vue?vue&type=template&id=2ed1bf62"
import script from "./IncidentIndex.vue?vue&type=script&lang=js"
export * from "./IncidentIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports